<template>
  <CurrentCheckoxesList
    :name="name"
    :role="role"
    :currentFiltersList="getCurrentFilterListyByName(name)"
    :selected-items="getSelectedFiltersByRoleAndNameOfFilter(role, filterName)"
    :filter-name="filterName"
    @set-selected-list="getSelectedList($event)"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import CurrentCheckoxesList from './CurrentCheckoxesList.vue'
import { getDateRangesAgoFromNow } from '@/library/time'

export default {
  components: { CurrentCheckoxesList },
  props: {
    role: {
      type: String,
      default: 'tour_operator',
    },

    name: {
      type: String,
      default: 'activity_period',
    },

    filterName: {
      type: String,
      default: 'date_of_state_registration',
    },
  },

  computed: {
    ...mapGetters([
      'getCurrentFilterListyByName',
      'getSelectedFiltersByRoleAndNameOfFilter',
    ]),
  },

  data() {
    return {
      type: 'activity_period',
      selectedList: [],
    }
  },

  methods: {
    getSelectedList(val) {
      this.$store.dispatch('updateFiltersByType', {
        selected_list_type: 'date_of_state_registration',
        role: this.role,
        back_end_id: 'back_end_period',
        filter_name: this.filterName,
        [this.filterName]: val,
      })
    },
  },
}
</script>

